module.exports = __webpack_public_path__ + "lp/img/blur_icn-on.bbf69033.svg";